module.exports = __webpack_public_path__ + "media/bootstrap-icons/controller-b114b4e1.svg";